export const MapMarker = require('./map-marker.png');